<template>
  <div class="bbp-copy-updates">
    <transition name="bbp-fade" appear>
      <BBPLoader v-if="loaderRun"></BBPLoader>
    </transition>
    <div class="bbp-copy-updates-header">
      <div class="bbp-copy-updates-header__title">Copy updates</div>
      <i class="bbp-icon-cross bbp-copy-updates-header__close" @click="closeForm"/>
    </div>
    <label class="bbp-copy-updates-search">
      <input class="bbp-input bbp-input_search bbp-copy-updates-search__input"
             type="text"
             @input="inputSearch"
             placeholder="Project"
      >
      <i class="bbp-icon-loupe bbp-copy-updates-search__icon"/>
    </label>
    <VuePerfectScrollbar class="bbp-copy-updates-body" :settings="{ wheelPropagation: false }">
      <div v-for="project in filteredProjects"
           :key="project.id"
           @click="selectedProject = project"
           class="bbp-copy-updates-body-list"
      >
        <span class="bbp-copy-updates-body-list__name"
              :class="{'bbp-copy-updates-body-list__name_active': selectedProject.id === project.id}"
        >
          {{project.name}}
        </span>
        <transition name="bbp-bounce">
          <i class="bbp-icon-check-mark bbp-copy-updates-body-list__checked"
             v-if="selectedProject.id === project.id"/>
        </transition>
      </div>
    </VuePerfectScrollbar>
    <div class="bbp-copy-updates-footer">
      <button class="bbp-button bbp-button_border bbp-button_border_gray" @click="closeForm">cancel</button>
      <button class="bbp-button" @click="copyProject">copy</button>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BBPLoader from '@/components/Main/BBPLoader/BBPLoader'
import ProjectsApi from '@/api/Projects/api'
import {debounce} from 'lodash'
export default {
  name: 'BBPCopyUpdates',
  components: {
    VuePerfectScrollbar,
    BBPLoader
  },
  props: ['projects', 'targetProject'],
  computed: {
    searchByName () {
      return debounce(this.searchNameProject, 1000)
    }
  },
  data () {
    return {
      selectedProject: {},
      loaderRun: false,
      filteredProjects: this.projects
    }
  },
  methods: {
    closeForm () {
      this.$emit('close')
    },
    copyProject () {
      this.loaderRun = true
      const copySteps = {
        copyProjectId: this.targetProject.id,
        targetProjectId: this.selectedProject.id
      }
      ProjectsApi.copySteps(copySteps)
        .then(() => {
          this.loaderRun = false
          this.closeForm()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    inputSearch (e) {
      const value = e.target.value
      this.searchByName(value)
    },
    searchNameProject (project) {
      this.getProjects(project)
    },
    getProjects (project) {
      this.loaderRun = true
      ProjectsApi.getProjects({
        page: 1,
        limit: 999,
        status: 1,
        search: project
      })
        .then(async (resp) => {
          this.filteredProjects = resp.data.projects.filter(item => item && !item.isRemoveInvoice)
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-copy-updates {
    @include global-font;
    display: grid;
    min-width: 521px;
    max-width: 90vw;
    height: 100%;
    max-height: calc(100vh - 60px);
    background: $color-white;
    border-radius: 8px;

    &-search {
      position: relative;
      display: flex;
      align-items: center;
      background: $color-white;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 5px;
      margin: 36px 20px;

      &__icon {
        position: absolute;
        right: 5px;
        font-size: 14px;
        color: $color-silver;
      }

      &__input {
        padding: 9px 11px;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        width: 100%;
      }
    }

    &-header {
      padding: 15px 22px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      &__title {
        font-weight: 500;
        font-size: 17px;
        text-align: center;
        line-height: 20px;
      }

      &__close {
        position: absolute;
        top: 11px;
        right: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-silver;
        width: 26px;
        height: 26px;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          color: $color-dusty-gray
        }
      }
    }

    &-body {
      padding: 0 20px;

      &-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        border-bottom: 1px solid $color-wild-sand;
        cursor: pointer;

        &:hover &__name {
          color: $color-accent;
        }

        &__name {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 17px;
          transition: 0.3s;

          &_active {
            color: $color-accent;
          }
        }

        &__checked {
          color: $color-accent;
          font-size: 16px;

          &:before {
            margin: 0;
          }
        }
      }
    }

    &-footer {
      position: sticky;
      bottom: 0;
      display: grid;
      grid-template-columns: repeat(2, 103px);
      grid-gap: 12px;
      justify-content: end;
      padding: 18px;
      border-top: 1px solid $color-mercury;
      background: $color-alabaster;
      border-radius: 0 0 8px 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPCopyUpdates.vue